export default "__VITE_ASSET__d0a7680d__"